module.exports = __webpack_public_path__ + "static/img/bug_in_jar.fab152b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bug_in_jar.svg
// module id = i1+9
// module chunks = 11